import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { SharedModule } from '../../shared/shared.module';

import { VistaUsuarioContainerComponent } from './components/vista-usuario-container/vista-usuario-container.component';
import { VistaUsuarioRoutingModule } from './vista-usuario-routing.module';
import { FEATURE_NAME, reducers } from './vista-usuario.state';

import { MuestreadorEffects } from '../roles/entity-muestreador/entity-muestreador.effects';
import { TecnicoResponsableEffects } from '../roles/entity-tecnico-responsable/entity-tecnico-responsable.effects';

import { RegistroPersonasEmpresasLibModule } from '@rpe/registro-personas-empresas-lib';
import { EntidadesProductivaEffects } from '../empresas/entity-entidad-productiva/entity-entidades-productiva.effects';
import { PersonasFisicaEffects } from '../empresas/entity-personas-fisica/entity-personas-fisica.effects';
import { PersonasJuridicaEffects } from '../empresas/entity-personas-juridica/entity-personas-juridica.effects';

import { TecnicosEffects } from '../roles/entity-tecnicos/entity-tecnicos.effects';

import { ComercializacionesEffects } from '../actividades/entity-comercializaciones/comercializaciones.effects';
import { DepositosEffects } from '../actividades/entity-depositos/depositos.effects';
import { LaboratoriosEffects } from '../actividades/entity-laboratorios/laboratorios.effects';
import { RPESubActividadesEffects } from '../actividades/entity-rpe-sub-actividades/rpe-sub-actividades.effects';
import { StepperEffects } from '../actividades/entity-stepper/stepper.effects';
import { CurrentEmpresaEffects } from '../empresas/entity-mis-empresas/entity-current-empresa.effects';
import { NaturalezaJuridicaEffects } from '../empresas/entity-naturalezas-juridica/entity-naturalezas-juridica.effects';

import { ActividadesGrupoEspecieEffects } from '../actividades/entity-actividades-grupo-especie/entity-actividades-grupo-especie.effects';
import { ActividadesEffects } from '../actividades/entity-actividades/entity-actividades.effects';
import { EntidadesProductivaActividadEffects } from '../actividades/entity-entidades-productiva-actividad/entity-entidades-productiva-actividad.effects';
import { TiposActividadEffects } from '../actividades/entity-tipos-actividad/entity-tipos-actividad.effects';
import { TiposDocumentoEffects } from '../persona/entity-tipos-documento/entity-tipos-documento.effects';
import { TiposTecnicoEffects } from '../persona/entity-tipos-tecnico/entity-tipos-tecnico.effects';
import { PersonaModule } from '../persona/persona.module';
import { IntegranteEffects } from '../roles/entity-integrante/entity-integrante.effects';
import { RolesActividadEffects } from '../roles/entity-roles-actividad/entity-roles-actividad.effects';
import { RPERolActividadesEffects } from '../roles/entity-rpe-rol-actividades/entity-rpe-rol-actividades.effects';
import { TiposRolEffects } from '../roles/entity-tipos-rol/entity-tipos-rol.effects';
import { PaisesDocumentoEffects } from '../ubicaciones/entity-paises-documento/paises-documento.effects';
import { UbicacionesModule } from '../ubicaciones/ubicaciones.module';
import { SitiosProcesamientoEffects } from '../actividades/entity-sitios-procesamiento/sitios-procesamiento.effects';
import { ViverosGrupoEspecieEffects } from '../actividades/entity-viveros-grupo-especie/entity-viveros-grupo-especie.effects';
import { TramiteEffect } from '../tramites/tramite.effects';
import { TipoEquipamientoEffect } from '../actividades/entity-tipos-equipamiento-laboratorio/tipo-equipamiento-laboratorio.effects';
import { EntityMaquinasMovilesEffects } from '../actividades/entity-maquinas-moviles/entity-maquinas-moviles.effects';
import { EntidadesProductivaTramiteEffects } from '../empresas/entidad-productiva-tramite/entity-entidades-productiva.effects';
import { MovimientoTramiteEffects } from '../tramites/movimiento-tramite/movimiento-tramite.effects';
import { SexoEffect } from '../persona/entity-sexo/entity-sexo.effects';
import { UserEffects } from '../persona/entity-usuarios/entity-user.effects';
import { TramiteStatusEffect } from '../tramites/tramite-status/tramite-status.effects';
import { EntityEstadoRolEffect } from '../roles/entity-estado-rol/entity-estados-rol.effects';
import { EntityEstadoLaboratorioEffects } from '../actividades/entity-estados-laboratorio/estados-laboratorio.effects';
import { EntityEtapasEmpresaEffects } from '../empresas/entity-etapas-empresa/entity-etapas-empresa.effects';
import { EntityAcreditacionEmpresaEffects } from '../empresas/acreditacion-empresa/entity-acreditacion-empresa.effects';
import { EntityEspeciesCertificablesEffects } from '../actividades/entity-especies-certificables/entity-especies-certificables.effects';

@NgModule({
  declarations: [VistaUsuarioContainerComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    SharedModule,
    VistaUsuarioRoutingModule,
    UbicacionesModule,
    RegistroPersonasEmpresasLibModule,
    PersonaModule,
    StoreModule.forFeature(FEATURE_NAME, reducers),
    EffectsModule.forFeature([
      ActividadesEffects,
      ActividadesGrupoEspecieEffects,
      ViverosGrupoEspecieEffects,
      CurrentEmpresaEffects,
      EntidadesProductivaActividadEffects,
      EntidadesProductivaEffects,
      IntegranteEffects,
      MuestreadorEffects,
      NaturalezaJuridicaEffects,
      UserEffects,
      PersonasFisicaEffects,
      PersonasJuridicaEffects,
      RolesActividadEffects,
      RPERolActividadesEffects,
      TecnicosEffects,
      TecnicoResponsableEffects,
      TiposRolEffects,
      TiposActividadEffects,
      TiposDocumentoEffects,
      TiposTecnicoEffects,
      PaisesDocumentoEffects,
      SexoEffect,
      EntityEtapasEmpresaEffects,
      EntityAcreditacionEmpresaEffects,
      EntityEspeciesCertificablesEffects,
      // actividades
      DepositosEffects,
      LaboratoriosEffects,
      SitiosProcesamientoEffects,
      EntityMaquinasMovilesEffects,
      TipoEquipamientoEffect,
      StepperEffects,
      ComercializacionesEffects,
      RPESubActividadesEffects,
      TramiteEffect,
      EntityEstadoRolEffect,
      EntidadesProductivaTramiteEffects,
      MovimientoTramiteEffects,
      TramiteStatusEffect,
      EntityEstadoLaboratorioEffects
    ])
  ],
  exports: [VistaUsuarioContainerComponent]
})
export class VistaUsuarioModule { }
